import { Dispatch, ReactNode, SetStateAction, createContext, useContext, useEffect, useReducer, useState } from 'react';

export type State = { [key: string]: any };
export type Action = { type: string; key?: string; payload?: any; operator?: string };

interface StateContextType {
    sortFilterState: State;
    moduleName: string;
    filterInitialState: State;
    isPresetLoaded: boolean;
    setIsPresetLoaded: Dispatch<SetStateAction<boolean>>;
    sortFilterDispatch: Dispatch<Action>;
    setFilterInitialState: Dispatch<SetStateAction<State>>;
}
const SortFilterStateContext = createContext<StateContextType | undefined>(undefined);

export const useSortFilterContext = () => {
    const context = useContext(SortFilterStateContext);
    if (!context) {
        throw new Error('useSortFilterContext must be used within a SortFilter Component');
    }
    return context;
};

interface StateProviderProps {
    children: ReactNode;
    initialState: State;
    initialModuleName: string;
    reducer: (state: State, action: Action) => State;
}

export const SortFilterContextProvider: React.FC<StateProviderProps> = ({
    children,
    initialState,
    initialModuleName,
    reducer,
}) => {
    const [sortFilterState, sortFilterDispatch] = useReducer(reducer, initialState, (initState) => initState);
    const [filterInitialState, setFilterInitialState] = useState(initialState);
    const [moduleName, setModuleName] = useState(initialModuleName);
    const [isPresetLoaded, setIsPresetLoaded] = useState(false);
    useEffect(() => {
        setModuleName(initialModuleName);
    }, [initialModuleName]);

    return (
        <SortFilterStateContext.Provider
            value={{ sortFilterState, moduleName, filterInitialState, sortFilterDispatch, setFilterInitialState, isPresetLoaded, setIsPresetLoaded }}
        >
            {children}
        </SortFilterStateContext.Provider>
    );
};
